var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShieldWarning = function SvgShieldWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.1,
    height: 18.8,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.592 3.494 8.897.074a.848.848 0 0 0-.694 0L.508 3.494A.854.854 0 0 0 0 4.275v.599a15.824 15.824 0 0 0 8.135 13.825.857.857 0 0 0 .83 0A15.823 15.823 0 0 0 17.1 4.874v-.599a.854.854 0 0 0-.508-.781zm-.682 1.115a15.146 15.146 0 0 1-7.34 12.974A15.146 15.146 0 0 1 1.23 4.609v-.046L8.57 1.3l7.34 3.263v.046zM7.8 7.695h1.5v6.84H7.8v-6.84zm0-3.42h1.5v1.71H7.8v-1.71z",
    fill: "#EDBB1D",
    fillRule: "nonzero"
  })));
};

export default SvgShieldWarning;